import BefundeIcon from '../resources/vector/Icon-Befunde.svg';
import BilderIcon from '../resources/vector/Icon-Bilder.svg';
import PassIcon from '../resources/vector/Icon-Pass.svg';
import KommunikationIcon from '../resources/vector/Icon-Kommunikation.svg';
import FinanzenIcon from '../resources/vector/Icon-Finanzen.svg';
import MooviesIcon from '../resources/vector/Icon-Moovies.svg';
import KrankheitsbilderIcon from '../resources/vector/Icon-Krankheitsbilder.svg';
import MedikamenteIcon from '../resources/vector/Icon-Medikamente.svg';
import MedizinischesNetzwerkIcon from '../resources/vector/Icon-med-Netzwerke.svg';
import JuristischeDokumenteIcon from '../resources/vector/Icon-Jur-Dokumente.svg';
import MedizinischeBibliothekIcon from '../resources/vector/Icon-Bibliothek.svg';
import LiveSaverIcon from '../resources/vector/Icon-Live-Safer.svg';

export const RootFolderIconMapping = [
  {
    apiIconId: 'MedicalResultIcon',
    icon: BefundeIcon,
    helptext: "Ambulante und stationäre Arztbriefe, Laborwerte, Messergebnisse, OP-Berichte, Untersuchungsdokumentation",
  },
  {
    apiIconId: 'ImagesIcon',
    icon: BilderIcon,
    helptext: "Bildgebung (Röntgen, CT, MRT, DVT, Endoskopie), Eigene Bilder (mit dem Smartphone selbst aufgenommene Fotos und Videos von krankhaften Veränderungen)",
  },
  {
    apiIconId: 'IdCardsIcon',
    icon: PassIcon,
    helptext: "Impfpass, Allergie-Ausweis, Mutterpass, U-Untersuchungen Kinder und Jugendliche, Implantatpass, Röntgenpass, Bonushefte, Behinderten-Ausweis, Transplantationsausweis",
  },
  {
    apiIconId: 'CommunicationIcon',
    icon: KommunikationIcon,
    helptext: "Mit Praxen und Kliniken, Versorgungseinrichtungen, Pflegediensten, Sanitärfachhandel",
  },
  {
    apiIconId: 'FinanceIcon',
    icon: FinanzenIcon,
    helptext: "Schriftwechsel mit GVK/PKV, Kostenvoranschläge, Rechnungen (Heil- und Hilfsmittel), Quittungen (nicht erstattungsfähige Medikamente, Selbstzahlerleistungen)",
  },
  {
    apiIconId: 'MooviesIcon',
    icon: MooviesIcon,
    helptext: "Atteste, Arbeitsunfähigkeitsbescheinigungen, Rezepte/Verordnungen",
  },
  {
    apiIconId: 'DiseasePatternsIcon',
    icon: KrankheitsbilderIcon,
    helptext: "Schlagworte zu bestimmten Krankheitsbildern",
  },
  {
    apiIconId: 'DrugsIcon',
    icon: MedikamenteIcon,
    helptext: "Foto der Medikamentenpackung oder des Medikationsplans",
  },
  {
    apiIconId: 'MedicalNetworkIcon',
    icon: MedizinischesNetzwerkIcon,
    helptext: "Ärzte in Praxen und Kliniken, Gesundheitsdienste (ambulante Pflege, Hebamme etc.), Arbeitgeber, Schule, Kindergarten (jeweils mit Mailadresse, Telefon, Webseite)",
  },
  {
    apiIconId: 'LegalDocumentsIcon',
    icon: JuristischeDokumenteIcon,
    helptext: "Patientenverfügung, Vollmachten, Transplantations-Einwiligung",
  },
  {
    apiIconId: 'MedicalLibraryIcon',
    icon: MedizinischeBibliothekIcon,
    helptext: "Artikel und Links",
  },
  {
    apiIconId: 'LiveSaferIcon',
    icon: LiveSaverIcon,
    helptext: "Blutgruppe, lebensbedrohliche Allergien, ernstere Vorerkrankungen, nächste Angehörige (Adresse, Mail und Telefon)",
  },
];

export default [
  {
    title: 'Befunde',
    icon: BefundeIcon,
  },
  {
    title: 'Bilder',
    icon: BilderIcon,
  },
  {
    title: 'Pässe/Ausweise',
    icon: PassIcon,
  },
  {
    title: 'Kommunikation',
    icon: KommunikationIcon,
  },
  {
    title: 'Finanzen',
    icon: FinanzenIcon,
  },
  {
    title: 'Moovies',
    icon: MooviesIcon,
  },
  {
    title: 'Krankheitsbilder',
    icon: KrankheitsbilderIcon,
  },
  {
    title: 'Medikamente',
    icon: MedikamenteIcon,
  },
  {
    title: 'Medizinisches Netzwerk',
    icon: MedizinischesNetzwerkIcon,
  },
  {
    title: 'Juristische Dokumente',
    icon: JuristischeDokumenteIcon,
  },
  {
    title: 'Medizinische Bibliothek',
    icon: MedizinischeBibliothekIcon,
  },
  {
    title: 'Live-Saver',
    icon: LiveSaverIcon,
  },
];
